import { render, staticRenderFns } from "./MenuClover.vue?vue&type=template&id=0316a468"
import script from "./MenuClover.vue?vue&type=script&lang=js"
export * from "./MenuClover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports